<template>
  <div class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 id="search-tips-modal-label" class="modal-title h3">
            Total Due
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p class="fs-5">
            Amounts displayed will take into account all charges, fees,
            adjustments, and payments made at the time in which the data is
            available. Details may be found in the
            <a :href="infoLink" @click="onDetailsClick">Billing Detail</a>
            section.
          </p>
        </div>

        <div class="modal-footer border-top-0">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    infoLink() {
      if (this.link) {
        return this.link;
      } else {
        return "#billing";
      }
    },
  },
  methods: {
    onDetailsClick() {
      if (!this.link) {
        setTimeout(() => {
          this.hideBackdrop("balance-info-modal");
        }, 300);
      }
    },
    hideBackdrop(modalId) {
      const modal = bootstrap.Modal.getInstance(
        document.getElementById(modalId)
      );
      modal.hide();
      const backdrops = document.getElementsByClassName("modal-backdrop");

      for (let i = 0; i < backdrops.length; i += 1) {
        backdrops[i].style.display = "none";
      }
    },
  },
  props: {
    link: {
      type: String,
      required: false,
    },
  },
};
</script>
